<template>
  <section v-show="isReady" class="block portal client portal password-change">
    <div class="portal__wrapper">
      <div class="portal__content">
        <div class="account__item account__item--edit account__item--gradient">
          <form class="account__content" @input="error = false">
            <h2 class="title--l">{{ getUiString(['password_reset', 'title']) }}</h2>
            <div class="text--emphasis">{{ getUiString(['password_reset', 'text']) }}</div>
            <div class="form__row">
              <lennoc-input id="newPassword" type="password" v-model="newPassword_1" :label="getUiString(['password_reset', 'new_password'])" :domClass="getErrorClass"></lennoc-input>
              <lennoc-input id="newPassword2" type="password" v-model="newPassword_2" :label="getUiString(['password_reset', 'confirm_password'])" :domClass="getErrorClass"></lennoc-input>
              <div class="form__group--error" v-if="error">
                <div class="error">{{ getErrorMessage }}</div>
              </div>
            </div>
            <button type="submit" class="button button--prim button-orange" @click.prevent="saveSettings">{{ getUiString(['password_reset', 'save_button_text']) }}</button>
          </form>
        </div>
      </div>
    </div>
    <lennoc-spinner v-if="busy" />
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

const MINIMUM_PASSWORD_LENGTH = 8
const NO_ERROR = 0
const ACCESS_DENIED = 1
const NETWORK_ERROR = 2
const UNKNOWN_ERROR = 3
const PASSWORDS_DONT_MATCH = 4
const PASSWORD_INVALID = 5

export default {
  name: 'CreateNewPassword',
  data () {
    return {
      isReady: false,
      busy: false,
      error: NO_ERROR,
      errorMessage: '',
      newPassword_1: '',
      newPassword_2: ''
    }
  },
  methods: {
    getTouchedClass (member) {
      return this.account[member] !== '' ? 'form__group--touched' : ''
    },
    async saveSettings () {
      if (this.newPassword_1 !== this.newPassword_2) {
        this.error = PASSWORDS_DONT_MATCH
      } else if (!this.testPassword(this.newPassword_1)) {
        this.error = PASSWORD_INVALID
        this.errorMessage = this.getUiString(['password_reset', 'requirements'])
      } else {
        this.busy = true
        const data = { requestId: this.$route.params.requestid, password: this.newPassword_1 }
        try {
          const result = await this.$store.dispatch('account/createNewPassword', data)
          if (result.status === 200) {
            this.$store.dispatch('postCreateNewPassword', result)
            this.$router.push('/')
          }
          if (result.status === 403) {
            this.error = ACCESS_DENIED
          }
          if (!result) {
            this.error = UNKNOWN_ERROR
          }
        } catch (error) {
          this.error = UNKNOWN_ERROR
        }
        this.busy = false
      }
    },
    testPassword (pw) {
      if (pw.length < MINIMUM_PASSWORD_LENGTH) {
        return false
      }
      if (pw.toUpperCase() === pw || pw.toLowerCase() === pw) {
        return false
      }
      return /\d+/.test(pw)
    }
  },
  beforeMount () {
    const data = { requestId: this.$route.params.requestid }
    this.$store.dispatch('account/checkPasswordRequest', data)
      .then(result => {
        if (result.data === 'expired') {
          this.$router.push('/forgot/expired')
        }
      },
      err => {
        if (err.message.indexOf('Network Error') > -1) {
          this.error = NETWORK_ERROR
        } else if (err.message.indexOf('403') > -1) {
          this.error = ACCESS_DENIED
        } else {
          this.error = UNKNOWN_ERROR
        }
      })
      .catch(() => { this.error = UNKNOWN_ERROR })
      .finally(() => { this.isReady = true })
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    getErrorClass () {
      return this.error ? 'form__group--error' : ''
    },
    getErrorMessage () {
      switch (this.error) {
        case ACCESS_DENIED:
          return this.getUiString(['login', 'login_fail'])
        case NETWORK_ERROR:
          return this.getUiString(['login', 'connection_error'])
        case UNKNOWN_ERROR:
          return this.getUiString(['password_reset', 'failed_unknown'])
        case PASSWORDS_DONT_MATCH:
          return this.getUiString(['password_reset', 'passwords_dont_match'])
        case PASSWORD_INVALID:
          return this.getUiString(['password_reset', 'requirements'])
        default:
          return ''
      }
    }
  }
}
</script>
